import { insertTextAtCursor } from "../../components/MonacoEditorHelper";
import { getKeyForAsset } from "./assetsI18n";

export const previewCode = (data : any, tab : any) => {
  const idTemplate = "%id%";
  const insertTemplate = tab.code;
  const code = insertTemplate.replace(idTemplate, getKeyForAsset(data.name));
  insertTextAtCursor(code, true);
}

export const previewAudioPlay = (data : any) => {
  const audio : HTMLAudioElement | null = document.querySelector('#audio-' + getKeyForAsset(data.name));
  if (!audio) return;
  audio.play();
}

export const showHelpContent = () => {
  //TODO
  //showHelpContent(asset.name, asset.content);
}


export function registerAsset(asset : any) {
  /*
  if (!asset) return;
  const newEntry = state.applicationData.userAssets.every(entry => entry.name !== asset.name);

  if (newEntry)  {
    state.applicationData.userAssets.push(asset);
  }*/
}
